"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AppStore = _interopRequireDefault(require("../store/AppStore"));

var _ModalActions = require("../../modules/modals/ModalActions");

var _RoutingService = _interopRequireDefault(require("./RoutingService"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ModalService = {
  showModal: function showModal(id) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var closeOther = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _RoutingService["default"].preventScroll();

    if (closeOther) {
      ModalService.hideModal();
    }

    _AppStore["default"].dispatch((0, _ModalActions.showModal)(id, props));
  },
  hideModal: function hideModal(id) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _RoutingService["default"].preventScroll();

    _AppStore["default"].dispatch((0, _ModalActions.hideModal)(id, props));
  },
  info: function info(text) {
    var closeable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _AppStore["default"].dispatch((0, _ModalActions.showModal)('INFO_MODAL', {
      text: text,
      closeable: closeable
    }));
  }
};
var _default = ModalService;
exports["default"] = _default;